import { RouterDomainConfig } from '@/config/domainRegistry/router/routerDomainConfig'
import { StoreDomainConfig } from '@/config/domainRegistry/store/storeDomainConfig'
import { ApolloDomainConfig } from '@/config/domainRegistry/apollo/apolloDomainConfig'
import { addDomainStoreModules } from '@/config/domainRegistry/store'
import { addDomainRoutes } from '@/config/domainRegistry/router'
import { addApolloConfigs } from '@/config/domainRegistry/apollo'

export interface DomainObject {
  vuex?: StoreDomainConfig[]
  router?: RouterDomainConfig
  apollo?: ApolloDomainConfig
}

let domains: DomainObject[] = []

export const registerDomain = (domainObject: DomainObject): void => {
  domains = [...domains, domainObject]
}

export const getApolloDomainConfigs = (): ApolloDomainConfig[] => {
  return domains
    .filter(({ apollo }) => apollo !== undefined)
    .map(({ apollo }) => apollo!)
}

export const getRouterDomainConfigs = (): RouterDomainConfig[] => {
  return domains
    .filter(({ router }) => router !== undefined)
    .map(({ router }) => router!)
}

export const getVuexDomainConfigs = (): StoreDomainConfig[] => {
  return domains
    .filter(({ vuex }) => vuex !== undefined)
    .map(({ vuex }) => vuex!)
    .reduce((acc, val) => acc.concat(val), [])
}

export const addDomains = async () => {
  await addDomainStoreModules()
  await addDomainRoutes()
  await addApolloConfigs()
}
